import {
  InputTextProps,
  InputTextComponentInnerProps,
  InputTextStyledComponentProps,
  InputTextTypes,
} from "./types"
import React from "react"
import { TextInput } from "~/ui/primitives"
import { InputTextCore } from "./core"
import styled from '~/ui/styled'
import { webInputStyles } from "~/ui/web-controls"

const StyledTextInput = styled(TextInput)<InputTextStyledComponentProps>`
  padding: ${({ theme }) => theme.space.sm};
  border-radius: ${({ theme }) => theme.radii.lg};
  color: ${({ theme }) => theme.colors.text};
  ${webInputStyles}
`

export const InputTextInnerBorderUnrefed: React.ForwardRefRenderFunction<
  TextInput,
  InputTextComponentInnerProps
> = ({ ...rest }, ref) => {
  return <StyledTextInput {...rest} ref={ref} />
}

export const InputTextBorderInner = React.forwardRef(InputTextInnerBorderUnrefed)

const InputTextBorder: React.ForwardRefRenderFunction<TextInput, InputTextProps> = (
  { label, validRule, ...rest },
  ref,
) => {
  return (
    <InputTextCore
      {...rest}
      label={label}
      validRule={validRule}
      type={InputTextTypes.INPUT_TEXT_BORDER}
      ref={ref}
    ></InputTextCore>
  )
}

export default React.forwardRef(InputTextBorder)
